import { Auth } from "aws-amplify";
import axios from 'axios';
import { API_GATEWAY_BASE_URL, USE_AUTH0, DEPLOYMENT_REGION } from "./constants";

export const Get = async (
    url,
    params = {},
    headers = {
        "content-type": "application/json"
    }
) => {

    const apiURL = composeAPIUrl(url);
    const apiHeaders = await componseHeader(headers);

    return axios.get(apiURL, { headers: apiHeaders, params }).then(res => res.data);

};

export const Put = async (
    url,
    requestBody = {},
    headers = { "content-type": "application/json" }
) => {

    const userName = await getUserName();
    const apiURL = composeAPIUrl(url);
    const apiHeaders = await componseHeader(headers);
    const bodyWithUser = userName ? {
        ...requestBody,
        userName
    }
        : requestBody;


    return axios.put(apiURL, bodyWithUser, { headers: apiHeaders }).then(res => res.data)
}

export const Post = async (
    url,
    requestBody = {},
    headers = { "content-type": "application/json" }
) => {

    const userName = await getUserName();
    const apiURL = composeAPIUrl(url);
    const apiHeaders = await componseHeader(headers);
    const bodyWithUser = userName ? { ...requestBody, userName } : requestBody;


    return axios.post(apiURL, bodyWithUser, { headers: apiHeaders }).then(res => res.data)
}

export const Delete = async (
    url,
    requestBody = {},
    headers = { "content-type": "application/json" }
) => {

    const userName = await getUserName();
    const apiURL = composeAPIUrl(url);
    const apiHeaders = await componseHeader(headers);
    const bodyWithUser = userName ? { ...requestBody, userName } : requestBody;

    return axios.delete(apiURL, { headers: apiHeaders, data: bodyWithUser }).then(res => res.data)
}

const componseHeader = async (headers) => {
    let apiHeaders = headers;

    if (USE_AUTH0) {
        // Auth0 flow
        try {
            if (window.getAuth0Token) {
                const token = await window.getAuth0Token();
                apiHeaders.authorization = `Bearer ${token}`;
            } else {
                console.error("Auth0 token getter not found");
                return "";
            }
        } catch (error) {
            console.error("Failed to get Auth0 token", error);
            return "";
        }
    } else if (DEPLOYMENT_REGION === "USA") {
        // Cognito flow
        let jwt;
        let cognitoSession;

        await Auth.currentSession().then(response => {
            jwt = response.getIdToken().getJwtToken();
            cognitoSession = response;
        });

        if (cognitoSession.isValid()) {
            apiHeaders.authorization = `Bearer ${jwt}`;
        } else {
            Auth.federatedSignIn();
            return "";
        }
    } else {
        // Keycloak flow (China)
        const token = localStorage.getItem("keycloakToken");

        if (token) {
            apiHeaders.authorization = `Bearer ${token}`;
        } else {
            console.error("Keycloak token not found");
            return "";
        }
    }

    return apiHeaders;
};

const getUserName = async () => {
    try {
        if (USE_AUTH0) {
            // Auth0 flow
            const auth0Username = localStorage.getItem("auth0Username");
            
            if (!auth0Username) return null;
            
            return auth0Username;
        } else if (DEPLOYMENT_REGION === "USA") {
            // Cognito flow
            const user = await Auth.currentAuthenticatedUser();
            const email = user?.attributes?.email;

            if (!email) return null;
            return email.split("@")[0];
        } else {
            // Keycloak flow (China)
            const keycloakUser = localStorage.getItem("keycloakUsername");

            if (!keycloakUser) return null;

            return keycloakUser;
        }
    } catch (err) {
        console.error("Failed to fetch userName", err);
        return null;
    }
};

const composeAPIUrl = (url) => {

    let apiURL = API_GATEWAY_BASE_URL + url;

    return apiURL;
};